export const DownloadCallback = () => {
  const url = window.location.pathname.split('/download/')[1];
  if (url) {
    window.location.href = url;
  }
  return null;
};
